import  React,{ useState, useRef } from 'react';
import service from './services/service'
import { useEffect } from 'react';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SelectButton } from 'primereact/selectbutton';
import { Checkbox } from 'primereact/checkbox';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import TableMapInfoManagement from './TableMapInfoManagement';
import ImportFileComponent from './ImportFileComponent';
import { Toast } from 'primereact/toast';
//seçilen tabloda crud işlemleri servislerini kullanan componenttir
//Ekleme güncelleme silme listeleme
export const TableCrud=(props)=> {
    const [loading, setLoading] = useState(false);
    const [selectedTable, setSelectedTable] = useState({});
    const [isManuelAdd, setIsManuelAdd] = useState(false);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [datas, setDatas] = useState([]);
    const [editRows, setEditRows] = useState([]);
    const [filters, setFilters] = useState({});
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyParams, setLazyParams] = useState(null);
    const [mapTool, setMapTool] = useState(null);
    const optionsDataAdd = ['Verileri Listele', 'Veri Ekle'];
    const [overlayMap, setOverlayMap] = useState(null);
    const popup_info_key = props.layerName + "-popup-info";
    let overlay = null;
  
    const toast = useRef(null);
    useEffect(() => {

        window["dynamicTableApiToken"] = props.tokenKey;

        let layerName = props.layerName;

        if (props.isActiveTable) {
            return getActiveTable();
        }
        if (props.table && props.table.id) {
            setSelectedTable(props.table);
            getColumns(props.table.id);
        }

    }, []);

    useEffect(() => {
        if ((props.table && props.table.id) || (selectedTable && selectedTable.id)) {
            if (selectedTable)
                getTableData(selectedTable.id);
            else
                getTableData(props.table.id);
        }
    }, [lazyParams, selectedTable]);
    let loadLazyTimeout = null;
    //İlgili tablonun dataları çekmek için kullanılır

    //Eğer kullanıcı bu componenti map tarafından çağırdaysa isActiveTable propertysi true ise aktif olan tablo sorgulanacaktır 
    const getActiveTable = () => {

        service.get(props.apiUrl + "/CustomerTable/GetActiveTableUser?_tableType=" + props.tableType).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                return;
            }
            let table = response.data[0];
            setSelectedTable(table);
            getColumns(table.id);

        }).catch(e => { });
    }
    //Seçili tablonun verilerinin servisten çekilmesini sağlar
    const getTableData = (tableId) => {

        if (loadLazyTimeout) {
            clearTimeout(loadLazyTimeout);
        }
        if (!lazyParams)
            return;

        let filterData = [];

        let sendKeys = Object.keys(lazyParams.filters);
        filterData = sendKeys.map(x => ({ key: x, value: lazyParams.filters[x].value?.toString() })).filter(x => x.value !== null && x.value);
        setLoading(true);

        loadLazyTimeout = setTimeout(() => {
            service.post(props.apiUrl + "/CustomerCrud/DynamicTableQuery?_tableId=" + tableId + "&_limit=" + lazyParams.rows + "&_offset=" + (lazyParams.page ? lazyParams.page : 0), filterData).then(response => {
                if (response === "") {
                    return;
                }
                if (!response.success) {
                    setDatas([]);
                    setLoading(false);
                    return;
                }
                setDatas(response.data.data);
                setTotalRecords(response.data.totalRecords);
                setLoading(false);
               // setLazyParams(lazyParams);
            }).catch(e => {
                console.log(e);
                setLoading(false);
            });

        }, Math.random() * 1000 + 250);

    }
    //İlgili tablonun kolon yapısını çeker
    const getColumns = (tableId) => {

        service.get(props.apiUrl + "/CustomerTable/GetTableColumns?_tableId=" + tableId).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                return;
            }
            let columns = response.data.filter(x => x.userAdded).map(x => ({
                name: x.name,
                type: x.type,
                required: x.isRequired,
                isActive: true,
                id: x.id
            }));
            setColumns(columns);

            let filtersTemp = { ...filters };
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].type === "Boolean") {
                    filtersTemp[columns[i].name] = { value: null, matchMode: FilterMatchMode.CONTAINS };
                }
                else {
                    filtersTemp[columns[i].name] = { value: '', matchMode: FilterMatchMode.CONTAINS };
                }
            }
            filtersTemp["id"] = { value: '', matchMode: FilterMatchMode.CONTAINS };
            setLazyParams({
                first: 0,
                rows: 10,
                page: 0,
                sortField: null,
                sortOrder: null,
                filters: filtersTemp
            });
        });
    }
    //İlgili tablonun kolon yapısını kullanarak yeni tablo satır datası oluşturmak için kullanılır.
    const newRow = () => {

        let rowsTemp = [...rows];
        let newRowItem = {};
        columns.forEach(x => newRowItem[x.name] = "");
        rowsTemp.push(newRowItem);
        setRows(rowsTemp);

    }
    //İlgii kolonun tipini almak için kullanılan hepler methoddur.
    const getColumn = (field) => {

        return columns.find(x => x.name === field);
    }
    //Satıra veri girilirken verinin ilgili fielda setlenmesini sağlayan methoddur
    const changeRow = (rowData, field, value, type) => {
        let allRows = [...rows];
        if (allRows.find(x => x === rowData)) {
            let findRow = allRows.find(x => x === rowData);
            findRow[field] = value;
            setRows(allRows);
        }
    }
    //Oluşturulan satırları ilgli tabloya kaydetmeye yarayan servisi çağıran methoddur.
    const save = () => {
        let keys = Object.keys(rows[0]);

        let allData = [];
        for (var i = 0; i < rows.length; i++) {
            let dataRows = [];
            for (var s = 0; s < keys.length; s++) {
                let data = {};
                data["columnName"] = keys[s];
                data["columnValue"] = rows[i][keys[s]].toString();
                data["columnType"] = getColumn(keys[s]).type
                dataRows.push(data);
            }
            allData.push({
                tableId: selectedTable.id,
                DynamicObjectDtos: dataRows
            });
        }
        service.post(props.apiUrl + "/CustomerCrud/AddRange", { list: allData }).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                toast.current.show({ severity: 'danger', summary: 'Bilgi', detail: response.message });
                return;
            }
            toast.current.show({ severity: 'success', summary: 'Bilgi', detail: "Veri Eklendi" });

        });
    }

    const renderHeader = () => {
        return (

            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-plus" label="Satır ekle" outlined onClick={newRow} />
                <Button type="button" icon="pi pi-save" label="Tabloya kaydet" outlined onClick={save} />
            </div>
        );
    };

    const deleteRowTemplate = (rowData) => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-trash" label="Sil" outlined onClick={() => setRows(rows.filter(x => x !== rowData))} />

            </div>
        );
    };

    //Veriler Listenilen tabloda güncelleme ve silme olaylarının yönetildiği templattir
    const processRowTemplate = (rowData) => {
        return (
            <div className="">
                {window.Object.checkPermissions(["table_management_data_delete"]) && <Button type="button" icon="pi pi-trash" label="Sil" className="p-button-danger" outlined onClick={() => {
                    deleteRowItem(selectedTable.id, rowData.id);
                }} />
                }
                {window.Object.checkPermissions(["table_management_data_edit"])&&
                <Button type="button" icon="pi pi-save" label="Güncelle" outlined onClick={() => {
                    updateRowItem(selectedTable.id, rowData.id);
                }} />
                }

            </div>
        );
    };

    const formatDate = (value) => {
        return value.toLocaleDateString('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };
    //Kolonun tipine göre giriş componenti ayarlayan methoddur.Render da çalışır
    const createTemplate = (rowData, { field }) => {
        switch (getColumn(field).type) {

            case "String":
                return <InputText placeholder={field} onChange={(e) => {
                    changeRow(rowData, field, e.target.value, "String");

                }} />
            case "Int32":
                return <InputNumber placeholder={field} onChange={(e) => {
                    changeRow(rowData, field, e.value.toString(), "Int32");

                }} />;
            case "Int64":
                return <InputNumber placeholder={field} onChange={(e) => {
                    changeRow(rowData, field, e.value.toString(), "Int64");

                }} />;

            case "DateTime":
                return <Calendar onChange={(e) => {
                    changeRow(rowData, field, formatDate(e.target.value), "String");
                }}></Calendar>


            case "Geometry":
                return (<InputText placeholder={field} onChange={(e) => {
                    changeRow(rowData, field, e.target.value, "String");

                }} />)
            case "Boolean":
                return <Checkbox inputId="isActive" name="isActive" onChange={(e) => {
                    changeRow(rowData, field, e.checked, "Boolean");
                }} checked={rowData[field]} />

            default: return "";
        }
    };
    const deleteRowItem = (tableId, rowId) => {
        const accept = () => {
            service.deleteRequest(props.apiUrl + "/CustomerCrud/DeleteItem?_tableId=" + tableId + "&_id=" + rowId).then(response => {
                if (response === "") {
                    return;
                }
                if (!response.success) {
                    return;
                }
                //getTableData(tableId);
                setDatas(datas.filter(x => x.id !== rowId));
            });
        }
        confirmDialog({
            message: 'Veri siliencektir',
            header: 'Uyarı',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept,
        });


    }
    //Güncelenen satırın kaydeilmesini sağlayan servisi kullanan methoddur
    const updateRowItem = (tableId, id) => {
        const accept = () => {
            let data = datas.find(x => x.id === id);

            let dataRows = [];
            for (var s = 0; s < columns.length; s++) {
                let updateData = {};
                updateData["columnName"] = columns[s].name;
                updateData["columnValue"] = data[columns[s].name] === null ? "" : data[columns[s].name].toString();
                updateData["columnType"] = columns[s].type
                dataRows.push(updateData);
            }
            let allRequestData = {
                tableId: selectedTable.id,
                dynamicObjectDtos: dataRows,
                id: data.id
            };

            service.post(props.apiUrl + "/CustomerCrud/UpdateItem", allRequestData).then(response => {
                if (response === "") {
                    return;
                }
                if (!response.success) {
                    return;
                }
              
                toast.current.show({ severity: 'sucess', summary: 'Bilgi', detail: "Veri Güncellendi" });
            });
        }
        confirmDialog({
            message: 'Veri güncellenecektir',
            header: 'Uyarı',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept,
        });
    }
    //Güncelenen satırı state günceller
    const onCellEditComplete = (e) => {
        let { rowData, newValue, field, originalEvent: event } = e;
        rowData[field] = newValue;
        event.preventDefault();
    };
    //Veriri güncellerirken datetime boolean gibi özel veri tipleri için komponent oluşturup onun üzerinden veri girişi yapılmasını sağlar
    const textEditor = (options) => {
        switch (getColumn(options.field).type) {
            case "String":
                return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />
            case "Boolean":
                return <Checkbox checked={options.value} onChange={(e) => options.editorCallback(e.checked)} />;
            case "DateTime":
                return <Calendar onChange={(e) => {
                    options.editorCallback(formatDate(e.target.value))
                }}></Calendar>

            default:
                return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
        }
    };

    const cellEditor = (options) => {
        return textEditor(options);
    };

    //Veri güncellenirken kullanulan methodlar

    //Veri listelenirlen tipine göre template oluşmasını sağlar
    const defaultTemplate = (rowData, { field }) => {
        switch (getColumn(field).type) {
            case "DateTime":
                return formatDate(new Date(rowData[field]));
            case "Geometry":
                return rowData["geoloc_wkt"];
            case "Boolean":
                return rowData[field] ? "Aktif" : "Pasif";
            default:
                return rowData[field]
        }
    }

    const onPage = (event) => {
        setLazyParams(event);
    }
    const onFilter = (event) => {
        setLazyParams(event);
    }
    //DAtetime ve Boolean alanlar gibi özel değerleri  sorgulamak için  eklenmiştir.Filitreleme işleminde çalışır
    const filterCustomTemplate = (options) => {
        let lazyParamsNew = { ...lazyParams };
        let value = lazyParamsNew.filters[options.field]["value"];

        switch (getColumn(options.field).type) {
            case "Boolean":
                return <TriStateCheckbox value={value ? value : null} onChange={(e) => {
                    options.filterApplyCallback(e.value)
                    lazyParamsNew.filters[options.field]["value"] = e.value;
                    //setLazyParams(lazyParamsNew);
                }} />;
            case "DateTime":
                return <Calendar onChange={(e) => {
                    options.filterApplyCallback(formatDate(e.value));
                    lazyParamsNew.filters[options.field]["value"] = formatDate(e.value);
                }}></Calendar>

            default: return null
        }
    };

    //Eğer ismap true şeklinde gösterilirse harita tarafı için müşterileri sorgulamak harita göstermek ve bilgi almak için menu oluşturulur.
    if (props.isMap ) {

        return (<TableMapInfoManagement {...props} table={selectedTable} columns={columns} />);
    }
    return (
        <div>
            <Toast ref={toast}></Toast>
         

            {props.isEdit &&
                <>
                <ConfirmDialog />
                <Button tooltip="Tablo Listesine Geri Dön" icon="pi pi-angle-left" onClick={props.onComplete} iconPos="right" />
                <h3>"{selectedTable.tableName}" tablosunda işlem yapmaktasınız</h3>

                {window.Object.checkPermissions(["table_management_data_add"]) && <SelectButton value={!isManuelAdd ? "Verileri Listele" : "Veri Ekle"} options={optionsDataAdd} onChange={(e) => {
                    let isAdd = e.value === "Verileri Listele" ? false : true;
                    setIsManuelAdd(isAdd);
                    if (!isAdd) {
                        getTableData(props.table.id);
                    }
                }
                } />}
                 


                </>
            }

            <br />
            {isManuelAdd &&
                <>
                    <ImportFileComponent onLoadData={(data) => {
                        setIsManuelAdd(false);
                    getTableData(props.table.id);
                    toast.current.show({ severity: 'info', summary: 'Bilgi', detail: data.message });

                    }} {...props} table={selectedTable} />

                <DataTable value={rows} responsiveLayout="scroll" header={window.Object.checkPermissions(["table_management_data_add"])  &&renderHeader}>
                        {columns.map(x => <Column field={x.name} header={x.name} body={createTemplate}></Column>)}
                        <Column header="Sil" body={deleteRowTemplate}></Column>
                    </DataTable>
                </>
            }
            {(!isManuelAdd && lazyParams && columns.length>0) &&
                <DataTable responsiveLayout="scroll" scrollable scrollHeight="50vh"             
                    onFilter={onFilter}
                    dataKey="id"
                    lazy
                    filters={lazyParams.filters}
                    loading={loading}
                    onPage={onPage}
                    first={lazyParams.first}
                    filterDisplay="row"
                    paginator
                    rows={lazyParams.rows}
                    selectionMode="single"
                    editMode={props.isEdit ? "cell" : "row"}
                    value={datas}
                    totalRecords={totalRecords}
                    responsiveLayout="scroll" >
                    <Column filter showFilterMenu={false} header="id" field="id"></Column>
                    {columns.map(x => <Column showFilterMenu={false} filterField={x.name} filterPlaceholder={x.name }
                        filter
                        filterElement={(x.type === "Boolean" || x.type === "DateTime") && filterCustomTemplate}
                        field={x.name} header={x.name}
                        editor={(options) => cellEditor(options)}
                        body={defaultTemplate}
                        onCellEditComplete={onCellEditComplete}

                    ></Column>)}
                    {props.isEdit && <Column header="İşlem" body={processRowTemplate}></Column>}

                </DataTable>
            }

        </div>
    )

}

export default TableCrud;